<template>

  <v-col  class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">{{ ActDescBtn }}
    <!-- v-model="dialogTipoEmpresaProducto" -->
<!-- <v-dialog v-model="dialogTipoEmpresaProducto"  persistent fullscreen hide-overlay transition="dialog-bottom-transition">
  </v-dialog> -->

        <v-toolbar dark color="indigo" dense>
          <v-app-bar-nav-icon @click.stop=";(acti_tb_data_TipoEmpresaProducto = true), filtroTipoEmpresaProducto()"></v-app-bar-nav-icon>

          <!-- <v-btn icon dark @click="cerrarmodalEtiqueta()">
              <v-icon>mdi-close</v-icon>
            </v-btn> -->

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-toolbar-title v-on="on">Configuración de tipo empresa producto</v-toolbar-title>
            </template>
            <i style="font-size: 20px" dark dense class="fa fa-info-circle">
              <span>Configuración de tipo empresa producto:</span>
              Crear, Modificar y desactivar Impresoras
            </i>
          </v-tooltip>

          <!-- <v-toolbar-title>Ordenes De Compras sugeridas</v-toolbar-title> -->

          <v-spacer></v-spacer>

          <v-card-actions>
            <v-sheet
              id="scrolling-techniques-7"
              class="overflow-x-auto"
              :max-width="windowSize.width - 70"
              color="transparent"
            >
              <v-btn-toggle>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn id="boton-mini" v-on="on" color="#90A4AE" small dark @click.prevent="NewInvConfiModalTipoEmpresaProducto">
                      <i style="font-size: 20px" class="fa fa-file-o"></i>
                      Limpiar
                    </v-btn>
                  </template>
                  <span>Limpiar</span>
                </v-tooltip>

                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn id="boton-mini" v-on="on" color="success" small dark @click.prevent="SaveInvConfiModalTipoEmpresaProducto">
                      <i style="font-size: 20px" class="fa fa-check-circle"></i>
                      <!-- fab x-small dark  -->
                      SALVAR
                    </v-btn>
                  </template>
                  <span>Guardar configuración</span>
                </v-tooltip>

                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-show="InvConfiModalTipoEmpresaProducto.codigo > 0"
                      id="boton-mini"
                      v-on="on"
                      color="red"
                      small
                      dark
                      @click.prevent="EliminarInvConfiModalTipoEmpresaProducto"
                    >
                      <i style="font-size: 20px" class="fa fa-trash"></i>
                      ELIMINAR
                    </v-btn>
                  </template>
                  <span>Eliminar configuración</span>
                </v-tooltip>
              </v-btn-toggle>
            </v-sheet>
          </v-card-actions>

          <v-btn color="grey darken-4" fab small @click.prevent="cerrarInvConfiModalTipoEmpresaProducto">
            <i style="font-size: 20px; color: white" class="fa fa-close"></i>
          </v-btn>

          <!-- <v-toolbar-items>
              <v-btn dark text @click="dialog = false">Save</v-btn>
            </v-toolbar-items> -->
        </v-toolbar>
        
        <!-- <v-list three-line subheader></v-list> -->
 <v-col cols="12" md="12" sm="12">
            <v-card color="grey lighten-3">
              <v-container>
                <v-form ref="formModalTipoEmpresaProducto" @submit.prevent="" v-model="valid" lazy-validation>
                  <v-row>
                    <!----------------------------------- columna 1 -->
                    <v-col cols="12" md="12" sm="12" class="pa-0 ma-0 py-0 my-0">
                      <v-text-field
                        class="fontSize12"
                        id="formdisabledInput"
                        v-model="InvConfiModalTipoEmpresaProducto.descripcion"
                        :rules="[$rules.required]"
                        autocomplete="off"
                        label="* LETRA PARA IDENTIFICAR SCHEMA:"
                        maxlength="1"
                        outlined
                        dense
                      >
                        <template v-slot:prepend>
                          <i style="font-size: 20px" class="fa fa-font"></i>
                        </template>
                      </v-text-field>
                    </v-col>
                    <!---------------------------------- fn columna 1 -->

                    <!------------------------------------- columna 2 -->
                    <v-col cols="12" md="12" sm="12" class="pa-0 ma-0 py-0 my-0">
                   <v-text-field
                        class="fontSize12"
                        id="formdisabledInput"
                        v-model="InvConfiModalTipoEmpresaProducto.schema"
                        :rules="[$rules.required]"
                        autocomplete="off"
                        label="* SCHEMA:"
                        outlined
                        dense
                      >
                        <template v-slot:prepend>
                          <i style="font-size: 20px" class="fa fa-scribd"></i>
                        </template>
                      </v-text-field>
                    </v-col>
                    <!------------------------------------ fn columna 2 -->
                    <v-col cols="12" md="6" sm="6" class="pa-0 ma-0 py-0 my-0">
                      <!------------------------------------------ Documentos -->
                                    <v-combobox autocomplete="off" dense outlined label="DOCUMENTO DE ENTRADA:" :items="RDocumentoEntrada"
                                      item-text="descripcion" :rules="[$rules.required]" v-model="InvConfiModalTipoEmpresaProducto.documentoEntrada"
                                      @blur="SelctCbAplicarDocumentoEntrada" @focus="cargarDocumentoEntrada" style="font-size:13px;">
                                      <template v-slot:prepend>
                                        <i style="font-size: 18px;" class="fa fa-book"></i>
                                      </template>
                                    </v-combobox>
                    </v-col>
                      <v-col cols="12" md="6" sm="6" class="pa-0 ma-0 py-0 my-0">
                      <!------------------------------------------ Documentos -->
                                    <v-combobox autocomplete="off" dense outlined label="DOCUMENTO DE SALIDA:" :items="RDocumentoSalida"
                                      item-text="descripcion" :rules="[$rules.required]" v-model="InvConfiModalTipoEmpresaProducto.documentoSalida"
                                      @blur="SelctCbAplicarDocumentoSalida" @focus="cargarDocumentoSalida" style="font-size:13px;">
                                      <template v-slot:prepend>
                                        <i style="font-size: 18px;" class="fa fa-book"></i>
                                      </template>
                                    </v-combobox>
                    </v-col>


                  </v-row>
                </v-form>
              </v-container>
            </v-card>
    </v-col>
        
     
<!-- ------------------------------------------------------ tb-data-TipoEmP-->
    <v-dialog
      label="myAlert"
      v-model="acti_tb_data_TipoEmpresaProducto"
      persistent
      max-width="100%"
      max-height="100%"
      transition="fab-transition"
    >
      <v-card>
        <v-toolbar flat color="#BDBDBD">
          <i style="font-size: 20px" class="fa fa-file-pdf-o"></i>
          <v-toolbar-title class="font-weight-light">REPORTE DE TIPO EMPRESA PRODUCTO</v-toolbar-title>
          <i style="font-size: 20px" class="fa fa-file-pdf-o"></i>

          <v-spacer></v-spacer>
          <v-btn color="grey darken-4" fab small @click="acti_tb_data_TipoEmpresaProducto = false">
            <i style="font-size: 20px; color: #dd4b39" class="fa fa-close"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-card>
            <v-card-title>
              <v-text-field v-model="searchTipoEmpresaProducto" @keyup="filtroTipoEmpresaProducto" label="Buscar" single-line hide-details>
                <template v-slot:prepend-inner>
                  <i style="font-size: 35px" class="fa fa-search"></i>
                </template>
              </v-text-field>
            </v-card-title>

            <v-data-table
            class="RowSelectColor elevation-1 RowSelectColor TbSize12"
              :headers="[
                { text: 'CÓDIGO', value: 'codigo', width: 'auto',class: ['no-gutters black--text']  },
                { text: 'DESCRIPCIÓN', value: 'descripcion', width: 'auto',class: ['no-gutters black--text']  },
                { text: 'SCHEMA', value: 'schema', width: 'auto',class: ['no-gutters black--text']  },
                { text: 'DOC. ENTRADA', value: 'entrada', width: 'auto',class: ['no-gutters black--text']  },
                { text: 'DOC. SALIDA', value: 'salida', width: 'auto',class: ['no-gutters black--text']  },
              ]"
              dense
              :items="listData"
              :search="searchTipoEmpresaProducto"
              @click:row="datostablaTipoEmpresaProducto"
            >
              <template v-slot:item.porciento="props">
                <span>{{ currencyFormatter(props.item.porciento) }}</span>
              </template>

               <template v-slot:item.entrada="props">
                <span v-if="props.item.documentoEntrada!=null">{{ props.item.documentoEntrada.descripcion }}</span>
              </template>

               <template v-slot:item.salida="props">
             <span v-if="props.item.documentoSalida!=null">{{ props.item.documentoSalida.descripcion }}</span>
              </template>



            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------ tb-data-TipoEmP-->

    <v-snackbar
      v-model="aalert.estado"
      :color="aalert.color"
      style="margin-top: 20%"
      :vertical="true"
      :timeout="120000"
      top="top"
    >
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>


  </v-col>
</template>

<script>
import AutoNumeric from "@/components/AutoNumericNuevo";
import { EventBus } from "@/event-bus";
export default {
  components: {
    AutoNumeric
  },

  mounted() {

  },

  created() {

  },

  data: () => ({

    windowSize: { width: "auto", height: "auto" },
    ejecucion:true,
    searchTipoEmpresaProducto:'',
    valid: true,
    Rproducto: [],
    listData:[],
    RDocumentoEntrada:[],
    RDocumentoSalida:[],
    dialogTipoEmpresaProducto:true,
  acti_tb_data_TipoEmpresaProducto:false,
   InvConfiModalTipoEmpresaProducto: {
        codigo: 0,
        descripcion: "",
        schema: "",
        borrado: false,
        documentoSalida:null,
        documentoEntrada:null

      },

      aalert: {
        estado: false,
        color: null
      },




  }),
  methods: {

  


    CerrarImpriEtiqueta() {
      //dialogEtiqueta = false
      this.$emit("EmitCerrarTipoEmpresaProducto", false);
    },

      cerrarInvConfiModalTipoEmpresaProducto() {

        console.log('BLANAKA-->')
       // this.dialogTipoEmpresaProducto = false
        this.NewInvConfiModalTipoEmpresaProducto()
        this.$emit("EmitCerrarTipoEmpresaProducto", false);
      },


NewInvConfiModalTipoEmpresaProducto() {
        this.InvConfiModalTipoEmpresaProducto = {
          codigo: 0,
          descripcion: "",
          schema: "",
          borrado: false,
          documentoSalida:null,
          documentoEntrada:null
        }
        this.ejecucion = true
        EventBus.$emit("loading", false)
      },

      SaveInvConfiModalTipoEmpresaProducto() {
        if (this.$refs.formModalTipoEmpresaProducto.validate()) {
          if (this.ejecucion == true) {
            EventBus.$emit("loading", true)
            this.ejecucion = false
            this.$axios
              .post(this.$hostname + this.$hName + "/tipoempresaproducto/save/", this.InvConfiModalTipoEmpresaProducto, {
                headers: this.$store.getters.GetheadersAxios,
              })
              .then((res) => {
                this.alerta("Dato guardado correctamente!", "bien")
              })
              .catch((error) => this.alerta("Dato no guardado correctamente", "error"))
          }
        } else {
          this.alerta("los campos en rojo son requeridos", "error")
        }
      },

      EliminarInvConfiModalTipoEmpresaProducto() {
        if (this.InvConfiModalTipoEmpresaProducto.codigo != 0 && this.InvConfiModalTipoEmpresaProducto.codigo != null) {
          if (this.$refs.formModalTipoEmpresaProducto.validate()) {
            this.$axios
              .post(this.$hostname + this.$hName + "/tipoempresaproducto/borrar/", this.InvConfiModalTipoEmpresaProducto, {
                headers: this.$store.getters.GetheadersAxios,
              })
              .then((res) => {
                this.alerta("Dato borrado correctamente", "bien")
              })
              .catch((error) => this.alerta("Dato no guardado correctamente", "error"))
          }
        }
      },
      filtroTipoEmpresaProducto() {
        var headers = this.$store.getters.GetheadersAxios
        this.$axios.get(this.$hostname + this.$hName + "/tipoempresaproducto/findall", { headers: headers }).then((res) => {
          this.listData = res.data
        })
      },

      datostablaTipoEmpresaProducto(e) {
        //this.dialogEtiquetaInv = false
        this.acti_tb_data_TipoEmpresaProducto = false
        this.InvConfiModalTipoEmpresaProducto = JSON.parse(JSON.stringify(e))

        // this.InvConfiModal.descripcion,
        //  thi.InvConfiModal.descripcion
      },


       cargarDocumentoEntrada() {

      this.$axios.get(this.$hostname + this.$hName + '/documento-inv/entradas', { headers: this.$store.getters.GetheadersAxios })
        .then(res => (this.RDocumentoEntrada = res.data))


    },

    cargarDocumentoSalida() {

      this.$axios.get(this.$hostname + this.$hName + '/documento-inv/salida', { headers: this.$store.getters.GetheadersAxios })
        .then(res => (this.RDocumentoSalida = res.data))


    },
    SelctCbAplicarDocumentoEntrada() {
      var _this = this;
      setTimeout(function () {
        if (_this.InvConfiModalTipoEmpresaProducto.documentoEntrada == null) {
          _this.InvConfiModalTipoEmpresaProducto.documentoEntrada = "";
        }

        if (!_this.InvConfiModalTipoEmpresaProducto.documentoEntrada.hasOwnProperty('codigo')) {
          _this.InvConfiModalTipoEmpresaProducto.documentoEntrada = "";
          _this.InvConfiModalTipoEmpresaProducto.documentoEntrada = null;
          _this.alerta("Seleccione un documento de entrada", "error");
          return;
        }
      }, 300);

    },


    SelctCbAplicarDocumentoSalida() {
  var _this = this;
      setTimeout(function () {
        if (_this.InvConfiModalTipoEmpresaProducto.documentoSalida == null) {
          _this.InvConfiModalTipoEmpresaProducto.documentoSalida = "";
        }

        if (!_this.InvConfiModalTipoEmpresaProducto.documentoSalida.hasOwnProperty('codigo')) {
          _this.InvConfiModalTipoEmpresaProducto.documentoSalida = "";
          _this.InvConfiModalTipoEmpresaProducto.documentoSalida = null;
          _this.alerta("Seleccione un documento de salida", "error");
          return;
        }
      }, 300);


    },


  alerta(e, l) {
        if (l == "bien") {
          ;(this.aalert.estado = true), (this.aalert.color = "success"), (this.aalert.nombre = e)
          this.NewInvConfiModalTipoEmpresaProducto()
        }
        if (l == "error") {
          ;(this.aalert.estado = true), (this.aalert.color = "error"), (this.aalert.nombre = e)
          this.ejecucion = true
        }
        EventBus.$emit("loading", false)

       
      },


  },


computed: {
    ActDescBtn() {
      this.windowSize = JSON.parse(JSON.stringify(this.$store.getters.GetwindowSize))
    }
  }

}
</script>

<style>

</style>